"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SYMBOL_QUERY_PARAM_VALUE_DIVIDER = exports.SYMBOL_QUERY_PARAM_DIVIDER = exports.SYMBOL_QUERY_PARAM_ALLOCATOR = exports.SUPPORT_PARAMS = exports.SORT_OPTIONS = exports.REGEXP_STRING_RANGE = exports.REGEXP_NUMBER_RANGE_OPERATOR = exports.REGEXP_NUMBER_RANGE = exports.REGEXP_NUMBER_1_TO_99 = exports.REGEXP_DATE_START = exports.REGEXP_DATE_NEW_CLIENT = exports.REGEXP_DATE = exports.QUERY_PARAM_SORT = exports.QUERY_PARAM_SEARCH = exports.QUERY_PARAM_QUALIFIERS = exports.PARAM_TYPE_VALUE = exports.PARAM_TYPE_SORT = exports.PARAM_TYPE_PRICE_RANGE = exports.PARAM_TYPE_NUMBER_RANGE = exports.PARAM_TYPE_DATE_RANGE = exports.PARAM_TYPE_BOOLEAN = exports.PARAM_START_DATE = exports.PARAM_SORT = exports.PARAM_PRICE = exports.PARAMS = exports.OTHER_PARAMS = exports.NUMBER_COMPARISON = exports.MAX_NIGHTS_OPTIONS = exports.LESS_THAN_EQUAL = exports.LESS_THAN = exports.KEY = exports.GREATER_THAN_EQUAL = exports.GREATER_THAN = exports.GDP = exports.CEL = exports.BOOLEAN_TRUE = exports.BOOLEAN_FALSE = void 0;
var BOOLEAN_FALSE = "false";
exports.BOOLEAN_FALSE = BOOLEAN_FALSE;
var BOOLEAN_TRUE = "true";
//
exports.BOOLEAN_TRUE = BOOLEAN_TRUE;
var REGEXP_DATE = "^(0[1-9]|1[0-2])\\/(0[1-9]|[12]\\d|3[01])\\/[12]\\d{3}$";
exports.REGEXP_DATE = REGEXP_DATE;
var REGEXP_DATE_START = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;

/**
 * @typedef REGEXP_DATE_NEW_CLIENT(YYYY-MM-DD)
 */
exports.REGEXP_DATE_START = REGEXP_DATE_START;
var REGEXP_DATE_NEW_CLIENT = "^[12]\\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$";
exports.REGEXP_DATE_NEW_CLIENT = REGEXP_DATE_NEW_CLIENT;
var REGEXP_NUMBER_RANGE = "^[\\d]+to[\\d]+$";
exports.REGEXP_NUMBER_RANGE = REGEXP_NUMBER_RANGE;
var REGEXP_NUMBER_1_TO_99 = "^\\b([1-9]|[1-9][0-9])\\b$";
exports.REGEXP_NUMBER_1_TO_99 = REGEXP_NUMBER_1_TO_99;
var REGEXP_STRING_RANGE = "^(gt{1,1}[1-9][0-9]?)|(gte{1,1}[1-9][0-9]?)|(lt{1,1}[1-9][0-9]?)|(lte{1,1}[1-9][0-9]?)$";
exports.REGEXP_STRING_RANGE = REGEXP_STRING_RANGE;
var REGEXP_NUMBER_RANGE_OPERATOR = "^[\\d]+plus$";
//
exports.REGEXP_NUMBER_RANGE_OPERATOR = REGEXP_NUMBER_RANGE_OPERATOR;
var KEY = "key";
//
exports.KEY = KEY;
var SYMBOL_QUERY_PARAM_ALLOCATOR = ":";
exports.SYMBOL_QUERY_PARAM_ALLOCATOR = SYMBOL_QUERY_PARAM_ALLOCATOR;
var SYMBOL_QUERY_PARAM_DIVIDER = "|";
exports.SYMBOL_QUERY_PARAM_DIVIDER = SYMBOL_QUERY_PARAM_DIVIDER;
var SYMBOL_QUERY_PARAM_VALUE_DIVIDER = ",";
//
exports.SYMBOL_QUERY_PARAM_VALUE_DIVIDER = SYMBOL_QUERY_PARAM_VALUE_DIVIDER;
var QUERY_PARAM_QUALIFIERS = "qualifiers";
exports.QUERY_PARAM_QUALIFIERS = QUERY_PARAM_QUALIFIERS;
var QUERY_PARAM_SEARCH = "search";
exports.QUERY_PARAM_SEARCH = QUERY_PARAM_SEARCH;
var QUERY_PARAM_SORT = "sort";
//
exports.QUERY_PARAM_SORT = QUERY_PARAM_SORT;
var PARAM_TYPE_BOOLEAN = "boolean";
exports.PARAM_TYPE_BOOLEAN = PARAM_TYPE_BOOLEAN;
var PARAM_TYPE_DATE_RANGE = "date_range";
exports.PARAM_TYPE_DATE_RANGE = PARAM_TYPE_DATE_RANGE;
var PARAM_TYPE_NUMBER_RANGE = "number_range";
exports.PARAM_TYPE_NUMBER_RANGE = PARAM_TYPE_NUMBER_RANGE;
var PARAM_TYPE_PRICE_RANGE = "price_range";
exports.PARAM_TYPE_PRICE_RANGE = PARAM_TYPE_PRICE_RANGE;
var PARAM_TYPE_SORT = "sort";
exports.PARAM_TYPE_SORT = PARAM_TYPE_SORT;
var PARAM_TYPE_VALUE = "value";
//  NUMBER COMPARISON
exports.PARAM_TYPE_VALUE = PARAM_TYPE_VALUE;
var GREATER_THAN_EQUAL = "gte";
exports.GREATER_THAN_EQUAL = GREATER_THAN_EQUAL;
var GREATER_THAN = "gt";
exports.GREATER_THAN = GREATER_THAN;
var LESS_THAN_EQUAL = "lte";
exports.LESS_THAN_EQUAL = LESS_THAN_EQUAL;
var LESS_THAN = "lt";
exports.LESS_THAN = LESS_THAN;
var NUMBER_COMPARISON = [GREATER_THAN_EQUAL, GREATER_THAN, LESS_THAN_EQUAL, LESS_THAN];
// SUPPORT PARAMS
exports.NUMBER_COMPARISON = NUMBER_COMPARISON;
var SUPPORT_PARAM_CROWN_AND_ANCHOR_NUMBER = "crownAndAnchorFilterApplied";
var SUPPORT_PARAM_RESIDENT = "exclusiveRate_RE";
var SUPPORT_PARAMS = [SUPPORT_PARAM_CROWN_AND_ANCHOR_NUMBER, SUPPORT_PARAM_RESIDENT];
// BRANDS
exports.SUPPORT_PARAMS = SUPPORT_PARAMS;
var CEL = "cel";
exports.CEL = CEL;
var GDP = "gdp";
// MAX NIGHTS FILTER OPTION
exports.GDP = GDP;
var MAX_NIGHTS_OPTIONS = 5;

// filters
exports.MAX_NIGHTS_OPTIONS = MAX_NIGHTS_OPTIONS;
var PARAM_ACCESSIBLE = {
  type: PARAM_TYPE_BOOLEAN,
  gdp: {
    key: "accessibility",
    valueInKey: true
  },
  props: {
    key: "accessible",
    param: QUERY_PARAM_SEARCH
  }
};
var PARAM_ADULTS = {
  type: PARAM_TYPE_VALUE,
  gdp: null,
  props: {
    key: "adults",
    param: QUERY_PARAM_SEARCH
  }
};
var PARAM_CABIN_CLASS = {
  type: PARAM_TYPE_VALUE,
  gdp: {
    key: "cabinClassType",
    valueInKey: false
  },
  props: {
    key: "cabinClass",
    param: QUERY_PARAM_SEARCH
  }
};
var PARAM_CHILDREN = {
  type: PARAM_TYPE_VALUE,
  gdp: null,
  props: {
    key: "children",
    param: QUERY_PARAM_SEARCH
  }
};
var PARAM_DEPARTURE_PORT = {
  type: PARAM_TYPE_VALUE,
  cel: {
    key: "departures"
  },
  gdp: {
    key: "departureCode",
    valueInKey: true
  },
  props: {
    key: "departurePort",
    param: QUERY_PARAM_SEARCH
  }
};
var PARAM_DESTINATION = {
  type: PARAM_TYPE_VALUE,
  cel: {
    key: "destinations"
  },
  gdp: {
    key: "destinationRegionCode",
    valueInKey: true
  },
  props: {
    key: "destination",
    param: QUERY_PARAM_SEARCH
  }
};
var PARAM_ID = {
  type: PARAM_TYPE_VALUE,
  gdp: {
    key: "groupId",
    valueInKey: false
  },
  props: {
    key: "id",
    param: QUERY_PARAM_SEARCH
  }
};
var PARAM_INFANTS = {
  type: PARAM_TYPE_VALUE,
  gdp: null,
  props: {
    key: "infants",
    param: QUERY_PARAM_SEARCH
  }
};
var PARAM_NIGHTS = {
  type: PARAM_TYPE_NUMBER_RANGE,
  cel: {
    key: "duration",
    ranges: {
      1: "2~5",
      2: "6~8",
      3: "9~11",
      4: "gte12"
    }
  },
  gdp: {
    key: "durationCode",
    valueInKey: true,
    ranges: {
      durationCode_2to5: "2~5",
      durationCode_6to8: "6~8",
      durationCode_9to11: "9~11",
      durationCode_12plus: "12"
    }
  },
  props: {
    key: "nights",
    param: QUERY_PARAM_SEARCH
  }
};
var PARAM_PACKAGE_CODE = {
  type: PARAM_TYPE_VALUE,
  gdp: {
    key: "packageCode",
    valueInKey: false
  },
  props: {
    key: "packageCode",
    param: QUERY_PARAM_SEARCH
  }
};
var PARAM_PORT = {
  type: PARAM_TYPE_VALUE,
  cel: {
    key: "portsOfCall"
  },
  gdp: {
    key: "location",
    valueInKey: true
  },
  props: {
    key: "port",
    param: QUERY_PARAM_SEARCH
  }
};
var PARAM_PRICE = {
  type: PARAM_TYPE_PRICE_RANGE,
  gdp: {
    key: "price",
    valueInKey: false
  },
  props: {
    key: "price",
    param: QUERY_PARAM_SEARCH
  }
};
exports.PARAM_PRICE = PARAM_PRICE;
var PARAM_SHIP = {
  type: PARAM_TYPE_VALUE,
  cel: {
    key: "ship"
  },
  gdp: {
    key: "shipCode",
    valueInKey: true
  },
  props: {
    key: "ship",
    param: QUERY_PARAM_SEARCH
  }
};
var PARAM_START_DATE = {
  type: PARAM_TYPE_DATE_RANGE,
  cel: {
    key: "sailStartDate:sailEndDate:dates"
  },
  gdp: {
    key: "dates",
    valueInKey: false
  },
  props: {
    key: "startDate",
    param: QUERY_PARAM_SEARCH
  }
};
exports.PARAM_START_DATE = PARAM_START_DATE;
var PARAM_TYPE = {
  type: PARAM_TYPE_VALUE,
  cel: {
    key: "cruiseType"
  },
  gdp: {
    key: "vacationTypeCode",
    valueInKey: true,
    mapping: {
      CO: "CRUISE",
      CT: "CRUISETOUR"
    }
  },
  props: {
    key: "type",
    param: QUERY_PARAM_SEARCH
  }
};
// qualifiers
var PARAM_CROWN_AND_ANCHOR_NUMBER = {
  // crownAndAnchorFilterApplied=true&crownAndAnchorSociety_memberId=379553520
  type: PARAM_TYPE_VALUE,
  gdp: {
    key: "crownAndAnchorSociety_memberId",
    support: SUPPORT_PARAM_CROWN_AND_ANCHOR_NUMBER,
    valueInKey: false
  },
  props: {
    key: "crownAndAnchorNumber",
    param: QUERY_PARAM_QUALIFIERS
  }
};
var PARAM_COUPON_CODE = {
  type: PARAM_TYPE_VALUE,
  gdp: {
    key: "promoCode",
    valueInKey: false
  },
  props: {
    key: "coupon",
    param: QUERY_PARAM_QUALIFIERS
  }
};
var PARAM_CURRENCY_CODE = {
  type: PARAM_TYPE_VALUE,
  gdp: {
    key: "currencyCode",
    valueInKey: false
  },
  props: {
    key: "currency"
  }
};
var PARAM_MILITARY = {
  type: PARAM_TYPE_BOOLEAN,
  gdp: {
    key: "exclusiveRate_MI",
    valueInKey: false
  },
  props: {
    key: "military",
    param: QUERY_PARAM_QUALIFIERS
  }
};
var PARAM_POLICE = {
  type: PARAM_TYPE_BOOLEAN,
  gdp: {
    key: "exclusiveRate_PO",
    valueInKey: false
  },
  props: {
    key: "police",
    param: QUERY_PARAM_QUALIFIERS
  }
};
var PARAM_RESIDENT = {
  // exclusiveRate_RE=true&exclusiveRate_RE_RE_FL=true
  type: PARAM_TYPE_VALUE,
  gdp: {
    key: "exclusiveRate_RE_RE",
    support: SUPPORT_PARAM_RESIDENT,
    valueInKey: true
  },
  props: {
    key: "resident",
    param: QUERY_PARAM_QUALIFIERS
  }
};
var PARAM_SENIOR = {
  type: PARAM_TYPE_BOOLEAN,
  gdp: {
    key: "exclusiveRate_SR",
    valueInKey: false
  },
  props: {
    key: "senior",
    param: QUERY_PARAM_QUALIFIERS
  }
};
var PARAM_PROMO_ID = {
  type: PARAM_TYPE_VALUE,
  gdp: {
    key: "promotionId",
    valueInKey: false
  },
  props: {
    key: "promoId",
    param: QUERY_PARAM_QUALIFIERS
  }
};
var PARAM_SORT = {
  type: PARAM_TYPE_SORT,
  cel: {
    key: "sortBy"
  },
  gdp: {
    key: "sort-by",
    valueInKey: false
  },
  props: {
    key: "senior",
    param: QUERY_PARAM_SORT
  }
};
exports.PARAM_SORT = PARAM_SORT;
var SORT_BY_NIGHTS = "NIGHTS";
var SORT_BY_PRICE = "PRICE";
var SORT_BY_RECOMMENDED = "RECOMMENDED";
var SORT_BY_SAIL_DATE = "SAILDATE";
var SORT_ORDER_ASC = "ASC";
var SORT_ORDER_DESC = "DESC";
var SORT_OPTION_NIGHTS_ASC = {
  gdp: "DURATION_LOW_TO_HIGH",
  cel: "DURATION_LOW_TO_HIGH",
  props: {
    by: SORT_BY_NIGHTS,
    order: SORT_ORDER_ASC
  }
};
var SORT_OPTION_NIGHTS_DESC = {
  gdp: "DURATION_HIGH_TO_LOW",
  cel: "DURATION_HIGH_TO_LOW",
  props: {
    by: SORT_BY_NIGHTS,
    order: SORT_ORDER_DESC
  }
};
var SORT_OPTION_PRICE_ASC = {
  gdp: "PRICE_LOW_TO_HIGH",
  cel: "PRICE_LOW_TO_HIGH",
  props: {
    by: SORT_BY_PRICE,
    order: SORT_ORDER_ASC
  }
};
var SORT_OPTION_PRICE_DESC = {
  gdp: "PRICE_HIGH_TO_LOW",
  cel: "PRICE_HIGH_TO_LOW",
  props: {
    by: SORT_BY_PRICE,
    order: SORT_ORDER_DESC
  }
};
var SORT_OPTION_RECOMMENDED = {
  gdp: "RECOMMENDED",
  cel: SORT_BY_RECOMMENDED,
  props: {
    by: SORT_BY_RECOMMENDED
  }
};
var SORT_OPTION_DATE = {
  gdp: SORT_BY_SAIL_DATE,
  cel: SORT_BY_SAIL_DATE,
  props: {
    by: SORT_BY_SAIL_DATE
  }
};
var SORT_OPTIONS = [SORT_OPTION_NIGHTS_ASC, SORT_OPTION_NIGHTS_DESC, SORT_OPTION_PRICE_ASC, SORT_OPTION_PRICE_DESC, SORT_OPTION_RECOMMENDED, SORT_OPTION_DATE];
//
exports.SORT_OPTIONS = SORT_OPTIONS;
var OTHER_PARAMS = [PARAM_CURRENCY_CODE];
exports.OTHER_PARAMS = OTHER_PARAMS;
var PARAMS = [PARAM_ACCESSIBLE, PARAM_ADULTS, PARAM_CABIN_CLASS, PARAM_CHILDREN, PARAM_COUPON_CODE, PARAM_CROWN_AND_ANCHOR_NUMBER, PARAM_DEPARTURE_PORT, PARAM_DESTINATION, PARAM_ID, PARAM_INFANTS, PARAM_MILITARY, PARAM_NIGHTS, PARAM_PACKAGE_CODE, PARAM_POLICE, PARAM_PORT, PARAM_PRICE, PARAM_PROMO_ID, PARAM_RESIDENT, PARAM_SENIOR, PARAM_SHIP, PARAM_SORT, PARAM_START_DATE, PARAM_TYPE];
exports.PARAMS = PARAMS;